module.exports = __webpack_public_path__ + "static/media/development.92b67955.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/development.png
// module id = 861
// module chunks = 6